__turbopack_context__.v({
  "indicator": "Radio-module__7NRA5a__indicator",
  "radio": "Radio-module__7NRA5a__radio",
  "radioButton": "Radio-module__7NRA5a__radioButton",
  "radioGroup": "Radio-module__7NRA5a__radioGroup",
  "root": "Radio-module__7NRA5a__root",
});
